import type { FC, RefObject, SVGProps } from "react"
import {
	IconTextSizeOutline18 as ALargeSmall,
	IconHeading1Outline18 as Heading1,
	IconHeading2Outline18 as Heading2,
	IconHeading3Outline18 as Heading3,
} from "nucleo-ui-outline-18"

import { Tooltip } from "@productlane/ui"

import type { Level } from "@tiptap/extension-heading"
import type { Editor } from "@tiptap/react"
import { EditorMenuDropdown } from "./editor-menu-dropdown"

interface HeadingDropdownProps {
	editor: Editor
	containerRef?: RefObject<HTMLDivElement | null>
}

export const EditorMenuHeadingDropdown: FC<HeadingDropdownProps> = ({
	editor,
	containerRef,
}) => {
	const headingLevels: {
		id: Level | 0
		label: string
		icon: LucideIcon
	}[] = [
		{ id: 0, label: "Regular Text", icon: ALargeSmall },
		{ id: 1, label: "Heading 1", icon: Heading1 },
		{ id: 2, label: "Heading 2", icon: Heading2 },
		{ id: 3, label: "Heading 3", icon: Heading3 },
	]

	const onSelect = (id: string | number) => {
		const level = id as Level | 0

		if (level === 0) {
			editor
				.chain()
				.focus(undefined, { scrollIntoView: false })
				.setParagraph()
				.run()
		} else {
			editor
				.chain()
				.focus(undefined, { scrollIntoView: false })
				.toggleHeading({ level })
				.run()
		}
	}

	const activeLevel = headingLevels.find(({ id }) => {
		return id === 0
			? editor.isActive("paragraph")
			: editor.isActive("heading", { level: id })
	})

	return (
		<Tooltip
			label={activeLevel?.label ?? headingLevels[0]?.label}
			shouldWrapChildren
		>
			<EditorMenuDropdown
				containerRef={containerRef}
				items={headingLevels}
				activeItem={activeLevel?.id}
				onSelect={onSelect}
				triggerIcon={activeLevel?.icon ?? ALargeSmall}
			/>
		</Tooltip>
	)
}

type LucideIcon = FC<SVGProps<SVGSVGElement>>
